import React from 'react';
import useCheckoutState from '../hooks/useCheckoutState';
import { checkoutTypes } from '../enums/checkout-types';

// Safari tints its status bar, toolbar and overscroll from the document's own background, not
// from the layout's painted elements. Embeds, popups and dashboard previews don't own the document.
export default function DocumentBackground({ color }) {
  const { checkoutType, isPreview, isTestingPayments } = useCheckoutState();
  const ownsDocument =
    (checkoutType === checkoutTypes.CHECKOUT || checkoutType === checkoutTypes.IFRAME) &&
    (!isPreview || isTestingPayments);

  if (!ownsDocument) return null;

  return <style>{`html { background-color: ${color}; }`}</style>;
}
